import React from "react"
import { RaisedButton } from "material-ui"
import { ITaskDocument } from "../../../models"
import moment from "moment"
import WorkflowStore from "../../../stores/WorkflowStore"
import strings from "../../../localization/strings"

interface IProps {
    task: ITaskDocument
    onCompleteTask(taskId: string): void
}

const TaskTypeIntercomTour: React.SFC<IProps> = (props: IProps) => {
    return (
        <div>
            {props.task.Completed &&
                <div style={{ marginBottom: 20 }}>
                    Completed: {moment(props.task.CompletedDate).format("hh:mma MM/DD/YYYY")}
                </div>
            }
            <RaisedButton
                label={props.task.Completed ? strings.RetakeTour : strings.TakeTour}
                style={{ marginLeft: 60, marginTop: -8 }}
                backgroundColor="#1181F2"
                labelColor="white"
                onClick={() => {
                    WorkflowStore.setShowWorkflowDrawer(false)
                    props.onCompleteTask(props.task.Id)
                    window["Intercom"] &&
                        window["Intercom"]("startTour", props.task.TaskType.TaskData1)
                }}
            />
        </div>
    )
}

export default TaskTypeIntercomTour